import React, { ReactNode } from 'react';
import { cn } from '@/helpers/classnames';

export interface ContainedIconProps {
  /**
   * Tailwind background class for the circular badge behind the icon. Without
   * it no badge is drawn and the icon renders at its natural size.
   */
  circleClassName?: string;
  /** Applied to the icon itself, for color and size. */
  className?: string;
  children?: ReactNode;
}

export const ContainedIcon: React.FC<ContainedIconProps> = ({
  children,
  circleClassName,
  className,
}) => (
  <div
    className={cn(
      'flex text-inherit',
      circleClassName && 'size-6 items-center justify-center rounded-full',
      circleClassName,
      className,
    )}
  >
    {children}
  </div>
);
